import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from '../assets/styles/components/TakeawayPaymentSummary'
import NavBarContainer from '../containers/components/NavBar'
import TakeawayOrderDetailList from '../containers/components/TakeawayOrderDetailList'
import TakeawayWaitingSummary from './../containers/components/TakeawayWaitingSummary'
import cx from 'classnames'

class TakeawayWaitingComponent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      backgroundMinHeight: window.screen.height,
      method: '',
      basket: {},
    }
  }

    updateParentState = (obj) => {
      this.setState(obj)
    }

    render () {
      const { takeawayOrders, basket, classes } = this.props
      const backgroundStyle = cx(classes['takeaway-waiting-background'])
      return (
        <div>
          <React.Fragment>
            <div className={backgroundStyle} style={{ minHeight: this.state.backgroundMinHeight }}>
              <NavBarContainer isTakeawaySummary />
              <TakeawayWaitingSummary
                status={basket.takeawayStatus}
                updateParentState={this.updateParentState}
              />
              <TakeawayOrderDetailList
                takeawayPaymentMethod={this.state.method}
                takeawayOrders={takeawayOrders}
                parentBasket={this.state.basket}
              />
            </div>
          </React.Fragment>
        </div>
      )
    }
}

export default injectSheet(styles)(TakeawayWaitingComponent)



// WEBPACK FOOTER //
// ./src/components/TakeawayWaiting.js